export default __webpack_public_path__ + "static/media/instanceDefault.f6c4c4cb.jpg";